import { render, staticRenderFns } from "./CrearPerfil.vue?vue&type=template&id=005f2815"
import script from "./CrearPerfil.vue?vue&type=script&lang=js"
export * from "./CrearPerfil.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports